<template>
  <el-dialog title="添加规格" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="addProductSpecInfo" label-width="100px">
      <el-form-item label="名称" prop="specName" :rules="[{ required: true, message: '规格名称不能为空', trigger: 'blur' }]">
        <el-input v-model="addProductSpecInfo.specName" placeholder="必填，请填写规格名称" />
      </el-form-item>

      <div class="form-tips">
        <span>如：颜色，大小，容量，尺寸，重量</span>
        <span style="float: right">如：红色，小，500ML，5.5寸，1kg</span>
      </div>

      <div v-for="(item, index) in addProductSpecInfo.specDetails" :key="item.id" class="spec-item">
        <el-form-item label="规格" :prop="`specDetails[${index}].detailName`"
          :rules="[{ required: true, message: '规格不能为空', trigger: 'blur' }]">
          <el-input v-model="item.detailName" placeholder="必填，请填写规格" />
        </el-form-item>
        <el-form-item label="值" :prop="`specDetails[${index}].detailValue`"
          :rules="[{ required: true, message: '规格值不能为空', trigger: 'blur' }]">
          <el-input v-model="item.detailValue" placeholder="必填，请填写规格值" />
        </el-form-item>
        <div class="spec-action">
          <i v-if="index !== addProductSpecInfo.specDetails.length - 1" class="el-icon-remove"
            @click="_deleteSpecDetail(item)" />
          <i v-if="index === addProductSpecInfo.specDetails.length - 1" class="el-icon-circle-plus"
            @click="_addSpecDetail" />
        </div>
      </div>

      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveProductSpecInfo">保存</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { saveProductSpec } from '@/api/goods/productSpecApi'
import { getShopId } from '@/api/shop/shopApi'
import { getUuid } from '@/utils/commonUtil'

export default {
  name: 'AddProductSpec',
  data() {
    return {
      dialogVisible: false,
      addProductSpecInfo: {
        specName: '',
        specDetails: []
      }
    }
  },
  methods: {
    open() {
      this.clearAddProductSpecInfo()
      this._addSpecDetail()
      this.dialogVisible = true
    },
    clearAddProductSpecInfo() {
      this.addProductSpecInfo = {
        specName: '',
        specDetails: []
      }
    },
    async saveProductSpecInfo() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.addProductSpecInfo.shopId = getShopId()
        const res = await saveProductSpec(this.addProductSpecInfo)

        if (res.code === 0) {
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存规格失败:', error)
      }
    },
    _addSpecDetail() {
      this.addProductSpecInfo.specDetails.push({
        id: getUuid(),
        detailName: '',
        detailValue: ''
      })
    },
    _deleteSpecDetail(item) {
      const index = this.addProductSpecInfo.specDetails.findIndex(d => d.id === item.id)
      if (index > -1) {
        this.addProductSpecInfo.specDetails.splice(index, 1)
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.form-tips {
  margin-bottom: 20px;
  color: #999;
}

.spec-item {
  display: flex;
  margin-bottom: 20px;
}

.spec-item>>>.el-form-item {
  margin-bottom: 0;
  margin-right: 20px;
}

.spec-action {
  line-height: 40px;
  margin-left: 10px;
}

.spec-action i {
  font-size: 20px;
  cursor: pointer;
  color: #409EFF;
}

.dialog-footer {
  text-align: right;
}
</style>